<div class="login-page">
  <div class="login-card">
    <h1>Masuk Admin</h1>
    <p>Masuk untuk mengelola visualizer template.</p>

    <form (ngSubmit)="login()">
      <div class="form-group">
        <label>Email</label>
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          placeholder="admin@gmail.com"
          required
        />
      </div>

      <div class="form-group">
        <label>Kata Sandi</label>
        <input
          type="password"
          name="password"
          [(ngModel)]="password"
          placeholder="admin123"
          required
        />
      </div>

      <p class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </p>

        <button type="submit" [disabled]="isLoading">
            {{ isLoading ? 'Memuat...' : 'Masuk' }}
        </button>
    </form>
  </div>
</div>
